import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "isolate bg-white" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]\"><svg class=\"relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]\" viewBox=\"0 0 1155 678\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)\" fill-opacity=\".3\" d=\"M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z\"></path><defs><linearGradient id=\"45de2b6b-92d5-4d68-a6a0-9b9b2abad533\" x1=\"1155.49\" x2=\"-78.208\" y1=\".177\" y2=\"474.645\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9089FC\"></stop><stop offset=\"1\" stop-color=\"#FF80B5\"></stop></linearGradient></defs></svg></div>", 1)
const _hoisted_3 = { class: "relative px-6 lg:px-8" }
const _hoisted_4 = { class: "mx-auto max-w-3xl pt-20 pb-32 sm:pt-48 sm:pb-40" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:mb-8 sm:flex sm:justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "relative overflow-hidden rounded-full py-1.5 px-4 text-sm leading-6 ring-1 ring-gray-900/10 hover:ring-gray-900/20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, " Seja bem vindo ao playgroud de widget da vmix")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold tracking-tight sm:text-center sm:text-6xl" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "mx-5 my-6 w-full bg-gray-800 shadow-2xl rounded-lg overflow-hidden"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div id=\"header-buttons\" class=\"py-3 px-4 flex\"><div class=\"rounded-full w-3 h-3 bg-red-500 mr-2\"></div><div class=\"rounded-full w-3 h-3 bg-yellow-500 mr-2\"></div><div class=\"rounded-full w-3 h-3 bg-green-500\"></div></div><span class=\"mt-1 text-white text-xl items-start p-2 px-6 pb-6\"> WebChat </span>", 2)
const _hoisted_10 = {
  id: "code-area",
  class: "mt-1 text-white text-xl items-start p-2 px-6 pb-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 text-white text-xl items-start p-2 px-6 pb-6" }, " Chat interno ", -1)
const _hoisted_12 = {
  id: "code-area",
  class: "mt-1 text-white text-xl items-start p-2 px-6 pb-6"
}
const _hoisted_13 = { class: "mt-8 flex gap-x-4 sm:justify-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" WebChat ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-indigo-200",
  "aria-hidden": "true"
}, "→", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Chat Interno ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Chat Interno Full ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Auditoria ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Notificações ")
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]\"><svg class=\"relative left-[calc(50%+3rem)] h-[21.1875rem] max-w-none -translate-x-1/2 sm:left-[calc(50%+36rem)] sm:h-[42.375rem]\" viewBox=\"0 0 1155 678\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"url(#ecb5b0c9-546c-4772-8c71-4d3f06d544bc)\" fill-opacity=\".3\" d=\"M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z\"></path><defs><linearGradient id=\"ecb5b0c9-546c-4772-8c71-4d3f06d544bc\" x1=\"1155.49\" x2=\"-78.208\" y1=\".177\" y2=\"474.645\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9089FC\"></stop><stop offset=\"1\" stop-color=\"#FF80B5\"></stop></linearGradient></defs></svg></div>", 1)

import { useClipboard } from '@vueuse/core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSections',
  setup(__props) {

    const internalchat = '<script defer async onload="init(fcd5015c-10d3-4e9c-b395-ec7ed8850165)" src="https://igorhalfeld-feedbacker-widget.netlify.app/internal.js">'
    const webchat = '<script defer async onload="init(fcd5015c-10d3-4e9c-b395-ec7ed8850165)" src="https://igorhalfeld-feedbacker-widget.netlify.app/internal.js">'
    const { isSupported, copy } = useClipboard()


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _hoisted_6,
              (_unref(isSupported))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", {
                        onClick: _cache[0] || (_cache[0] = () => _unref(copy)(webchat))
                      }, _toDisplayString(webchat))
                    ]),
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", {
                        onClick: _cache[1] || (_cache[1] = () => _unref(copy)(internalchat))
                      }, _toDisplayString(internalchat))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'WebChat' },
                  title: "COPIAR URL WEBCHAT",
                  class: "inline-block rounded-lg bg-indigo-600 px-4 py-1.5 text-base font-semibold leading-7 text-white shadow-sm ring-1 ring-indigo-600 hover:bg-indigo-700 hover:ring-indigo-700"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_RouterLink, {
                  to: { name: 'chat.internal' },
                  title: "INTERNAL CHAT",
                  class: "inline-block rounded-lg px-4 py-1.5 text-base font-semibold leading-7 text-gray-100 ring-1 ring-sky-900/10 hover:ring-sky-900/20 bg-gradient-to-r from-emerald-500 to-teal-900"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: { name: 'chat.internal.full' },
                  title: "Chat interno full",
                  class: "inline-block rounded-lg px-4 py-1.5 text-base font-semibold leading-7 text-gray-100 ring-1 ring-blue-900/10 hover:ring-blue-900/20 bg-gradient-to-r from-cyan-500 to-blue-500"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: { name: 'audit.home' },
                  title: "Auditoria",
                  class: "inline-block rounded-lg px-4 py-1.5 text-base font-semibold leading-7 bg-gradient-to-r text-gray-100 from-indigo-500 from-20% to-emerald-500 to-90%"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: { name: 'notify.home' },
                  title: "Notificações",
                  class: "inline-block rounded-lg px-4 py-1.5 text-base font-semibold leading-7 text-gray-100 ring-1 ring-red-900/10 hover:ring-red-900/20 bg-gradient-to-r from-purple-500 to-pink-500"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _hoisted_20
          ])
        ])
      ])
    ])
  ]))
}
}

})